import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerLicense } from '@syncfusion/ej2-base';
import axios from 'axios';
import keycloak from './keycloak';

// --- Authentification : joint le token Keycloak à CHAQUE appel vers l'API CMS ---
// Le front s'authentifiait sur Keycloak mais ne transmettait JAMAIS son token au back : les ~168
// appels axios partaient sans identification (le back les acceptait, il n'a aucune auth).
// Un intercepteur GLOBAL évite de modifier 168 sites d'appel un par un.
//
// /!\ On ne l'envoie QU'À NOTRE API CMS. Surtout pas aux autres hôtes (price-eat, api.fid,
// dl.alta-pos, scw...) : envoyer le token d'un opérateur à un tiers serait une fuite.
// Les appels AltaFid posent déjà leur propre Authorization, mais vers REACT_APP_IP_FID -> hors
// périmètre, aucun risque d'écrasement (vérifié).
//
// keycloak.token est relu à chaque requête (jamais mis en cache) : il est rafraîchi en continu
// par AutoRefreshToken (App.js), donc on envoie toujours un token valide.
const CMS_API_BASE = `${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}`;
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (url.startsWith(CMS_API_BASE) && keycloak.token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${keycloak.token}`;
  }
  return config;
});

registerLicense('Ngo9BigBOggjHTQxAR8/V1NHaF5cXmVCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWH9fdnVVQ2ZfUER0X0I=');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();
